/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWhatsapp,
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';

import Button from '../elements/Button';
import Services from '../data/services';
import Industries from '../data/industries';
import AboutItems from '../data/about';

function slugify(text) {
  return text
    .toLowerCase()
    .replace(/[\s_&]+/g, '-')
    .replace(/[^\w-]+/g, '');
}

export default function Footer() {
  const socialLinks = [
    { icon: faFacebookF, href: 'https://facebook.com/FajTech', label: 'Facebook' },
    { icon: faInstagram, href: 'https://www.instagram.com/fajtech.ca/', label: 'Instagram' },
    { icon: faLinkedinIn, href: 'https://www.linkedin.com/company/fajtech-ca/posts/', label: 'LinkedIn' },
    { icon: faYoutube, href: 'https://www.youtube.com/@fajtechit', label: 'YouTube' },
    { icon: faWhatsapp, href: 'https://api.whatsapp.com/send?phone=14039264494', label: 'WhatsApp' },
  ];

  return (
    <footer className="relative bg-gradient-to-b from-surface-900 to-[#070d1a] text-white overflow-hidden">
      {/* Decorative top accent */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-green-400/40 to-transparent" />

      <div className="container mx-auto px-6 py-16 relative z-10">

        {/* TOP GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10">

          {/* Column: Services */}
          <div>
            <h4 className="text-sm font-bold mb-4 uppercase tracking-wider text-brand-green-400">All Services</h4>
            <ul className="space-y-2.5">
              {Services.map((s) => (
                <li key={s}>
                  <Button
                    type="link"
                    href={`/services/${slugify(s)}`}
                    className="text-sm text-gray-400 hover:text-brand-green-300 transition-colors"
                  >
                    {s}
                  </Button>
                </li>
              ))}
            </ul>
          </div>

          {/* Column: Industries */}
          <div>
            <h4 className="text-sm font-bold mb-4 uppercase tracking-wider text-brand-green-400">All Industries</h4>
            <ul className="space-y-2.5">
              {Industries.map((i) => (
                <li key={i}>
                  <Button
                    type="link"
                    href={`/industries/${slugify(i)}`}
                    className="text-sm text-gray-400 hover:text-brand-green-300 transition-colors"
                  >
                    {i}
                  </Button>
                </li>
              ))}
            </ul>
          </div>

          {/* Column: About */}
          <div>
            <h4 className="text-sm font-bold mb-4 uppercase tracking-wider text-brand-green-400">About FAJTech</h4>
            <ul className="space-y-2.5">
              {AboutItems.map((a) => (
                <li key={a}>
                  <Button
                    type="link"
                    href={`/about/${slugify(a)}`}
                    className="text-sm text-gray-400 hover:text-brand-green-300 transition-colors"
                  >
                    {a}
                  </Button>
                </li>
              ))}
            </ul>
          </div>

          {/* Column: Location */}
          <div>
            <h4 className="text-sm font-bold mb-4 uppercase tracking-wider text-brand-green-400">Location</h4>
            <div className="text-sm text-gray-400 mb-3">
              Alberta: 415 PINEWIND RD NE, CALGARY
            </div>
            {/* Maps Mini Widget */}
            <div className="w-full h-[120px] rounded-lg overflow-hidden border border-white/10 shadow-sm opacity-90 hover:opacity-100 transition-opacity">
              <iframe
                title="FAJTech Office Location - Mini Widget"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2503.7!2d-114.0!3d51.08!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTHCsDA0JzQ4LjAiTiAxMTTCsDAwJzAwLjAiVw!5e0!3m2!1sen!2sca!4v1710000000000!5m2!1sen!2sca"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mt-12 mb-10" />

        {/* Bottom */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">

          {/* Badges */}
          <div className="flex flex-wrap justify-center items-center gap-6">
            {[
              { src: '/badges/Cisco_Solution_Partner.png', alt: 'Cisco Partner' },
              { src: '/badges/dell_partnerdirect_registered.png', alt: 'Dell Partner' },
              { src: '/badges/McAffe.png', alt: 'McAfee Partner' },
              { src: '/badges/HP_partner.png', alt: 'HP Partner' },
              { src: '/badges/fortinet_partner.png', alt: 'Fortinet Partner' },
            ].map((badge) => (
              <img
                key={badge.alt}
                src={badge.src}
                alt={badge.alt}
                className="h-10 lg:h-11 object-contain opacity-60 hover:opacity-100 transition-opacity grayscale hover:grayscale-0"
              />
            ))}
          </div>

          {/* Social + Links */}
          <div className="flex flex-col md:items-end items-center space-y-4">

            <div className="flex gap-3 items-center">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={social.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full
                    bg-white/5 text-gray-400 text-sm
                    hover:bg-brand-green-500 hover:text-white hover:shadow-green-glow
                    transition-all duration-300"
                >
                  <FontAwesomeIcon icon={social.icon} />
                </a>
              ))}
            </div>

            <div className="flex gap-4 text-sm text-gray-500">
              <Button type="link" href="/privacy-policy" className="text-gray-500 hover:text-brand-green-300 transition-colors">Privacy Policy</Button>
              <Button type="link" href="/remote-support" className="text-gray-500 hover:text-brand-green-300 transition-colors">Remote Support</Button>
            </div>
          </div>

        </div>

        {/* COPYRIGHT */}
        <div className="mt-10 text-sm text-gray-600 text-center">
          © {new Date().getFullYear()} FAJTech. All rights reserved.
        </div>

      </div>
    </footer>
  );
}
